import React, { useEffect } from 'react';
import { motion } from 'framer-motion'; // Assuming framer-motion is installed for motion.div
import AOS from 'aos'; // Assuming AOS is used for data-aos attributes
import 'aos/dist/aos.css'; // Import AOS CSS

const OurJourneyPage = () => {

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="min-h-screen relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-100 to-white"></div>



      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4">
        <div className="">
          {/* <motion.div
            data-aos="fade-right"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-slate-500 to-gray-500 rounded-lg transform -rotate-6"></div>
            <img
              src={img} // Using a placeholder instead of /path-to-your-journey-image.jpg
              alt="Our Journey"
              className="relative rounded-lg shadow-2xl w-full h-[600px] object-cover transform hover:rotate-3 transition-transform duration-500"
              onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/800x600/cccccc/333333?text=Image+Error'; }}
            />
          </motion.div> */}

          <div data-aos="text-center" className="space-y-6">
         <div className="text-center mb-12 group" data-aos="fade-up">
  <h1 className="relative inline-block font-serif text-5xl md:text-6xl text-gray-500 tracking-tight pb-5">
    Our<br className="md:hidden" /> Journey

    {/* Animated underline span */}
    <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-gray-900 to-gray-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out rounded-full" />
  </h1>
</div>
            <p className="text-gray-600 text-lg leading-relaxed">
              At VIZAURA, we believe walls deserve more than just paint. They are a canvas for expression, a way to bring identity into any space. What started as a small studio has grown through collaboration, creativity and trust, shaping hundreds of spaces across cities, homes and hearts.
            </p>
            <motion.div
              className="grid grid-cols-2 gap-6 mt-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {[
                { number: "350+", label: "Projects Completed" },
                { number: "10+", label: "Cities Covered" },
                { number: "100%", label: "Client Satisfaction" },
                { number: "18+", label: "Years Experience" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
                  whileHover={{ y: -5 }}
                >
                  <div className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-500 to-gray-500">
                    {stat.number}
                  </div>
                  <div className="text-gray-600 mt-1">{stat.label}</div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurJourneyPage;
